// extracted by mini-css-extract-plugin
export default {"products":"bB-z","card":"cB-z","oosMessaging":"dB-z"};